import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Registration} from '../model/registration';
import {RegistrationResponse} from '../model/registration_response';
import {catchError, Observable, retry, throwError} from 'rxjs';
import {MessageSet} from '../model/message_set';
import {Message} from '../model/message';
import {RegisteredKeyRequest} from "../model/registered_key_request";
import {ReceiveMessageRequest} from "../model/receive_message_request";

@Injectable({providedIn: 'root'})
export class RequestsService {
	constructor(private readonly httpClient: HttpClient) {}

	/**
	 * Register a (public key, JWT hash) pair
	 */
	register(registration: Registration): Observable<RegistrationResponse> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json'
			})
		};
		return this.httpClient.post<RegistrationResponse>(this.buildUrl('/register'), registration, httpOptions).pipe(
			retry(3) // retry a failed request up to 3 times
		);
	}

	/**
	 * Get a registered (public key, JWT hash) pair
	 */
	getUser(apiToken: string, id: RegisteredKeyRequest): Observable<Registration> {
		const httpOptions = {
			headers: new HttpHeaders({
				Authorization: apiToken
			})
		};
		return this.httpClient.post<Registration>(this.buildUrl(`/user/getKey`), id ,httpOptions).pipe(
			retry(3) // retry a failed request up to 3 times
		);
	}

	/**
	 * Send a message to a user
	 */
	sendMessage(apiToken: string, msg: Message): Observable<void> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Authorization: apiToken
			})
		};
		return this.httpClient.post<void>(this.buildUrl(`/user/message`), msg, httpOptions).pipe(
			retry(3) // retry a failed request up to 3 times
		);
	}

	/**
	 * Get all messages sent to a user
	 */
	getMessages(apiToken: string, id: ReceiveMessageRequest, from?: string | null): Observable<MessageSet> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Authorization: apiToken
			})
		};
		return this.httpClient.post<MessageSet>(
			from != null ? this.buildUrl(`/user/get/message`, ['from', from]) : this.buildUrl(`/user/get/message`),
			id,
			httpOptions
		);
	}

	private buildUrl(endpoint: string, ...params: [string, string][]): string {
		let url = `/v1${endpoint}?`;
		for (const param of params) {
			url = url.concat(`${param[0]}=${param[1]}`);
		}
		return url;
	}
}
